import { AceLanguage, NotebookTypes } from '@mode/notebooks/contract';
import { isPresent } from '@mode/shared/util-js';
import { createSelector, Selector } from 'reselect';
/*
Contains legacy store selector paths
TODO: Will contain NgRx selectors once we migrate legacy notebook state to NgRx state
Based on selectors in notebook.selectors.ts
*/
import * as LegacyNotebookSelectors from '../notebook/legacy-notebook.selectors';

const notebookPath = (state: any) => state?.client?.notebooks;

const cellPath = (state: any) => notebookPath(state)?.cells;

function cellRunPath(state: any) {
  return notebookPath(state).cellRuns;
}

export const runsExecutionCountsArray = (state: any) => cellRunPath(state).executionCounts;

export const cellFrozenArray = (state: any) => cellPath(state).frozen;

export const selectedCellFrozen = createSelector(
  LegacyNotebookSelectors.selectedCellToken,
  cellFrozenArray,
  (cellToken, frozen) => frozen.get(cellToken)
);

export const isEditing = (state: any) => notebookPath(state)?.editor?.isEditing;

export function createIsCellEditingSelector(cellToken: string): Selector<any, boolean> {
  return createSelector(
    LegacyNotebookSelectors.selectedCellToken,
    isEditing,
    (selectedToken: string | null, editing: boolean) => selectedToken === cellToken && editing
  );
}

export function createCellExecutionCountSelector(cellToken: string): Selector<any, number> {
  const lastRunToken = (state: any) => cellPath(state).lastRunTokens.get(cellToken);
  return createSelector(lastRunToken, runsExecutionCountsArray, (runToken, executionCounts) =>
    executionCounts.get(runToken)
  );
}

export function createMarkdownViewModeSelector(cellToken: string) {
  return createSelector(
    createIsCellEditingSelector(cellToken),
    (state: any) => LegacyNotebookSelectors.cellContentTypesArray(state).get(cellToken),
    (editing, contentType) => !editing && contentType === NotebookTypes.ContentType.Markdown
  );
}

export function createCellAceLangSelector(cellToken: string): Selector<any, AceLanguage> {
  return createSelector(
    LegacyNotebookSelectors.selectedNotebookType,
    LegacyNotebookSelectors.cellContentTypesArray,
    (notebookType: NotebookTypes.NotebookType, cellTypes: Map<string, NotebookTypes.ContentType>): AceLanguage => {
      const contentType = cellTypes?.get(cellToken);

      if (contentType === NotebookTypes.ContentType.Markdown) {
        return AceLanguage.Markdown;
      }
      switch (notebookType) {
        case NotebookTypes.NotebookType.R:
          return AceLanguage.R;
        default:
          return AceLanguage.Python;
      }
    }
  ) as unknown as Selector<any, AceLanguage>;
}
